import {
	Table, Pagination, Tag
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import "antd/lib/spin/style/index.css"
import {
	reSpecificWeightActions
}from './store/actions'
import Notifications from '../../../helpers/Notifications'
import "../style.css"
import {
	useDebounce
}from 'use-debounce'
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import LocalLoading from '../../../components/Loading/Local'
import AddWeightsFromFileModal from './addModal'

const ReSpecificWeight = () => {
	const [addVisible, setAddVisible] = useState(false)
	const [search, setSearch] = useState('')
	const [searchValue] = useDebounce(search, 500)
	const [table, setTable] = useState(null)
	const [count, setCount] = useState(0)
	const [page, setPage] = useState(1)
	const { paged, isSending, changed } = useSelector(state => state.reSpecificWeightReducer)
	const dispatch = useDispatch()
	const pageSize = 10

	const onPaginationChange = (value) => {
		setPage(value)
		const params = {
			name     : searchValue?.trim(),
			page     : value,
			pageSize : pageSize
		}
		getPagedAll(params)
	}

	useEffect(() => {
		return () => {
			dispatch(reSpecificWeightActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 10)
			onPaginationChange(page)
		}
	}, [changed])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	const getPagedAll = (values) => {
		dispatch(reSpecificWeightActions.getPaged(values))
	}

	const upload = (values) => {
		dispatch(reSpecificWeightActions.upload(values))
	}

	const getExampleFile = (values) => {
		dispatch(reSpecificWeightActions.getExampleFile(values))
	}

	const columns = [
		{
			dataIndex : 'code',
			key       : 'code',
			title     : 'Код',
			width     : "5%"
		},
		{
			dataIndex : 'name',
			key       : 'name',
			title     : 'Название',
			width     : "25%"
		},
		{
			dataIndex : 'categories',
			key       : 'categories',
			title     : 'Категории',
			width     : "30%",
			render    : categories => (<div style={ { display: "inline-grid" } }>
				{ categories.map((obj) => {
					return (
						<span key={ obj }>
							{ `${ obj } ` }
						</span>
					)
				}) }
			</div>)
		},
		{
			dataIndex : 'monolithic',
			key       : 'monolithic',
			title     : 'Монолитное домостроение',
			width     : "10%"
		},
		{
			dataIndex : 'brick',
			key       : 'brick',
			title     : 'Кирпичное домостроение',
			width     : "10%"
		},
		{
			dataIndex : 'block',
			key       : 'block',
			title     : 'Блочное домостроение',
			width     : "10%"
		},
		{
			dataIndex : 'smr',
			key       : 'smr',
			title     : 'СМР',
			width     : "10%"
		}
	]

	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={ 64 }
					placeholder="Введите название/код"
					onChange={ (e) => setSearch(e.target.value) }
				/>
				<CustomButton
					className="add-nsi"
					type="green"
					onClick={ () => {
						setAddVisible(true)
					} }
				>
					Обновить
				</CustomButton>
			</div>
			<Table
				columns={ columns }
				dataSource={ table }
				loading={ { spinning  : isSending,
					indicator : <LocalLoading /> } }
				pagination={ false }
				scroll={ { x: 1200 } }
			/>
			{ count > pageSize
				? (
					<Pagination
						showQuickJumper
						current={ page }
						pageSize={ pageSize }
						showSizeChanger={ false }
						size="small"
						total={ count }
						onChange={ onPaginationChange }
					/>)
				: null }
			 <AddWeightsFromFileModal
				changed={ changed }
				getExampleFile={ getExampleFile }
				isSending={ isSending }
				setVisible={ setAddVisible }
				upload={ upload }
				visible={ addVisible }
			 />
		</>
	)
}

export default ReSpecificWeight